import { ca } from '@cian/analytics';

export const trackBlockShow = (offersIds: number[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'show_sopr',
    label: 'promo_offers',
    products: offersIds.map(id => ({
      id,
      offerType: 'promo',
    })),
  });
};

type TClickType = 'to_offers' | 'to_promo' | 'to_jk' | 'to_listing' | 'to_listing_modal';

interface IBlockClickParams {
  offersIds: number[];
  clickType: TClickType;
}

export const trackBlockClick = ({ offersIds, clickType }: IBlockClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'click_sopr',
    label: 'promo_offers',
    products: offersIds.map(id => ({
      id,
      offerType: 'promo',
      extra: {
        clickType,
      },
    })),
  });
};
